import { appPath } from '@fs/zion-config'
import useMarkdownContent from '../../../hooks/useMarkdownContent'

type UseHandbookMarkdownContentResult = {
  markdown: string
  error: string | null
  loading: boolean
  locales: string[]
  selectedLocale: string | null
  setSelectedLocale: (locale: string) => void
}

export default function useHandbookMarkdownContent(baseFilename: string): UseHandbookMarkdownContentResult {
  return useMarkdownContent(
    baseFilename,
    `${appPath}/place-reports/handbook-directory/`,
    `${appPath}/place-reports/handbook-content`
  )
}
